import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import ProductCatalogPage from "./features/product/pages/ProductCatalogPage";
import ProductDetailPage from "./features/product/pages/ProductDetailPage";
import AboutPage from "./pages/AboutPage";
import CheckoutPage from "./pages/CheckoutPage";
import Cart from "./features/cart/components/Cart";
import { CartProvider } from "./stores/cartStore";
import { ToastProvider } from "./contexts/ToastContext";

function App() {
  const [isCartOpen, setIsCartOpen] = useState(false);

  const handleCartClick = () => {
    setIsCartOpen(true);
  };

  const handleCartClose = () => {
    setIsCartOpen(false);
  };

  return (
    <ToastProvider>
      <CartProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Header onCartClick={handleCartClick} />
            <Routes>
              <Route path="/" element={<ProductCatalogPage />} />
              <Route path="/product/:id" element={<ProductDetailPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
            </Routes>
            <Cart isOpen={isCartOpen} onClose={handleCartClose} />
          </div>
        </Router>
      </CartProvider>
    </ToastProvider>
  );
}

export default App;
